import { Component } from '@angular/core';

@Component({
  selector: 'app-customer-work-orders',
  templateUrl: './customer-work-orders.component.html',
})
export class CustomerWorkOrdersComponent {}
